import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Principles from './pages/Principles';
import Resources from './pages/Resources';
import Assessment from './pages/Assessment';
import Research from './pages/Research';
import Success from './pages/Success';

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om" element={<About />} />
          <Route path="/principer" element={<Principles />} />
          <Route path="/resurser" element={<Resources />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/forskning" element={<Research />} />
          <Route path="/framgang" element={<Success />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;